<template>
  <div class="permission">
    <h2>Se alle anbefalinger</h2>
    <p>Vi deler gerne ud af vores faglige viden og ekspertise. Til gengæld vil vi gerne kontakte dig med information og hjælp til at komme i gang.</p>

    <form v-on:submit.prevent="setFBAnswer" autocomplete="off" role="presentation">
      <fieldset class="form-group">
        <label for="username">Dit fulde navn</label>
        <input v-model="firm.user.name" type="text" class="form-control" id="username" placeholder="Fornavn Efternavn" required>
      </fieldset>
      <div class="permission-2col">
        <div class="permission-col">

          <fieldset class="form-group">
            <label for="phone">Dit telefonnummer</label>
            <input v-model="firm.phone" type="text" class="form-control" id="phone" placeholder="F.eks 12 34 56 78" required  @keydown="isNumber()"  @keyup="checkLengthPhone(firm.phone, 8)">
          </fieldset>

        </div>
        <div class="permission-col">
          <fieldset class="form-group">
            <label for="email">Din e-mail</label>
            <input @blur="verifyEmail" v-model="firm.email" type="email" class="form-control" id="email" placeholder="F.eks din@email.dk" required>
            <span v-if="mailCheckedEmail" class='form--notice form--suggestEmail' @click="setNewMail">
              Mente du <span>{{ mailCheckedEmail }}</span>?
            </span>
            <span v-if="mailfalse" class='form--notice form--suggestEmail' @click="setNewMail">
              Indtast korrekt email
            </span>
          </fieldset>
        </div>
      </div>
      <div class="mt-5">
        <div>
          <fieldset class="permission-check">
            <input v-model="firm.user.permissionemail" type="checkbox" class="permission-check-input" id="permission" required>
            <appPermissionText />
          </fieldset>
        </div>
        <div>
          <button type="submit" class="btn btn-light">Send</button>
        </div>
      </div>
    </form>


  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import {mapActions} from 'vuex';
import {db} from '../database/firebase';
import Axios from 'axios';
import Mailcheck from 'mailcheck';
import PermissionText from '@/components/modular/PermissionText.vue';
export default {
  name: 'softpermissionemail',
  components: {
    appPermissionText: PermissionText
  },
  data () {
    return {
      auto:'',
      current:0,
      mailCheckedEmail: undefined,
      autocomplete:false,
      firmActive: true,
      mailfalse: false
    }
  },
  computed: {
    ...mapGetters([
      'survey',
      'globalC',
      'answers',
      'answersCount',
      'surveyIsActive',
      'firm',
      'avarage'
    ])
  },

  methods: {
    ...mapActions([
      'setPrev',
    ]),
    popupP(what){
      console.log(what);
      this.$store.state.global.whatPop = what;
    },
    setNewMail(){
      this.firm.email = this.mailCheckedEmail;
      this.mailCheckedEmail = undefined;
      this.mailfalse = false
    },
    verifyEmail: function () {
      let self = this;

      Mailcheck.run({
        email: self.firm.email,
        suggested: function (suggestion) {
          self.mailCheckedEmail = suggestion.full;
        },
        empty: function () {

        }
      })

    },
    checkLengthPhone(len,max){
      if(len.length > max){
        this.firm.phone = len.substring(0, len.length - 1);
      }
    },
    isNumber: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46 || charCode == 190) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    isActive (index) {
      return index === this.current
    },
    setFBAnswer(){
      var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      if( !re.test(this.firm.email) ){
        this.mailfalse = true
        return true
      }
      if(this.firm.user.permissionemail){
        var s = this.$route.params.survey
        var postData = {
          MarketingCampaignId: this.globalC.varsEmail.MarketingCampaignId,
          email: this.firm.email,
          mdbIdentifier: this.globalC.varsEmail.mdbIdentifier,
          Datasource: this.globalC.varsEmail.Datasource,
          ProjectName: this.survey[s].name,
          kundetype: this.globalC.varsEmail.kundetype,
          isCustomer: this.firm.isCustomer,
          emailpermission1_Id: this.globalC.varsEmail.emailpermission1_Id,
          emailpermission1: this.globalC.varsEmail.emailpermission1,
          phone_1: this.firm.phone,
          phonepermission1_Text: this.globalC.varsEmail.phonepermission1_Text,
          phonepermission1: this.globalC.varsEmail.phonepermission1,
          text_name1: this.globalC.varsEmail.text_name1,
          text_1: 'https://sikkerhedstjek.dk/rapport/'+s+'/'+this.firm.firmId+'',
          text_name3: this.globalC.varsEmail.text_name3,
          text_3: this.firm.employees,
          text_name4: this.globalC.varsEmail.text_name4,
          text_4: this.firm.location,
          text_name5: this.globalC.varsEmail.text_name5,
          text_5: this.firm.sqm,
          text_name6: this.globalC.varsEmail.text_name6,
          text_6: 'nope',
          text_name7: "saelgerid",
          text_7: this.firm.saelgerid,
          text_name8: "editguid",
          text_8: this.firm.userid
        }

        //db.ref('email').child(s).child(this.firm.firmId).set(postData);

        var bodyFormData = new FormData;
        for (var k in postData){
            if (postData.hasOwnProperty(k)) {
              bodyFormData.append(k, postData[k]);
              //bodyFormData.set(k, postData[k]);
            }
        }
        console.log(bodyFormData);

        let axiosConfig = {
            responseType: 'json',
            headers: {'Content-Type': 'multipart/form-data'}
        };

        Axios.post('https://mdbprodssl.falck.com/marketingform/MarketingServicePost.ashx', bodyFormData, axiosConfig )
        .then((res) => {

          console.log(res);
        })
        .catch((err) => {
          console.log("AXIOS ERROR: ", err);
        })
        this.$router.push({ path: '/rapport/'+s+'/'+this.firm.firmId+'' });
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.form--notice{
  margin-top: 10px;
  display: block;
}
.form--notice >>> span{
  text-decoration: underline;
  cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/components/softPermissionEmail.vue